export const BUILD_VERSION = '1782146919';
